import type { AlchemyType } from './types';
import { ALL_ALCHEMY_TYPES } from './types';

type Rng = () => number;

/** Sorteia um tipo alquímico. */
export function randomAlchemyType(rng: Rng = Math.random): AlchemyType {
  const idx = Math.min(Math.floor(rng() * ALL_ALCHEMY_TYPES.length), ALL_ALCHEMY_TYPES.length - 1);
  return ALL_ALCHEMY_TYPES[idx]!;
}

/** Assinatura determinística de uma combinação de tipos. */
export function typeSignature(types: ReadonlyArray<AlchemyType>): string {
  return [...types].sort().join('-');
}

/** Hue offset por tipo (rotações no círculo HSL — usado em U3 para colorir). */
const HUE_OFFSETS: Readonly<Record<AlchemyType, number>> = {
  Fire: 0,
  Water: 200,
  Earth: 120,
  Air: 180,
  Life: 90,
  Shadow: 270,
};

export function typeToHueOffset(t: AlchemyType): number {
  return HUE_OFFSETS[t];
}

/** Gera todas as 63 combinações C(6,1) + C(6,2) + ... + C(6,6). */
export function allTypeCombinations(): AlchemyType[][] {
  const result: AlchemyType[][] = [];
  function combine(start: number, current: AlchemyType[]): void {
    if (current.length > 0) result.push([...current]);
    for (let i = start; i < ALL_ALCHEMY_TYPES.length; i++) {
      current.push(ALL_ALCHEMY_TYPES[i]!);
      combine(i + 1, current);
      current.pop();
    }
  }
  combine(0, []);
  return result;
}
